import React from 'react'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import InfoBlock from 'app/components/InfoBlock'
import Button from 'app/components/ButtonDefault'

import './styles.scss'
const bc = 'has-irregular-work-week'

const HasIrregularWorkWeek = ({
  t,
  i18n: { language },
  isShowHasIrregularWorkWeekBlock,
  handleSubmit,
  onSubmitAndGoToNotifications,
}) => {
  if (!isShowHasIrregularWorkWeekBlock) {
    return null
  }
  return (
    <InfoBlock>
      <div className={cn(`${bc}__text`, { [`${bc}__text__${language}`]: language })}>
        {t('user:Do you have an irregular work week?')}
      </div>
      <form onSubmit={handleSubmit}>
        <div className={`${bc}__buttons`}>
          <Button sm primary onClick={handleSubmit(onSubmitAndGoToNotifications)}>
            {t('Yes')}
          </Button>
          <Button sm secondary type="submit">
            {t('No')}
          </Button>
        </div>
      </form>
    </InfoBlock>
  )
}

export default withTranslation()(HasIrregularWorkWeek)
